import { URL_Vicidial } from '../variables';
// vicidialApi.js
const source = 'test';
const user = 'userapizxw2';
const pass = 'aJe72PawJ1S0SlgD';

export async function externalHangup({ agentId, value }) {
    try {
         await fetch(URL_Vicidial + `?source=${source}&user=${user}&pass=${pass}&function=external_hangup&agent_user=${agentId}&value=${value}`, {
            method: 'GET',
            mode: 'no-cors'
        });

        return true;
    } catch (error) {
        console.error('Error updating status:', error);
        return false;
    }
}

export async function externalResume({ agentId, value }) {
    try {
        const response = await fetch(URL_Vicidial + `?source=${source}&user=${user}&pass=${pass}&function=external_pause&agent_user=${agentId}&value=${value}`, {
            method: 'GET',
            mode: 'no-cors'
        });
            return true;
    } catch (error) {
        console.error('Error updating status:', error);
        return false;
    }
}

export async function externalStatus({ agentId, value }) {
    try {
        const response = await fetch(URL_Vicidial + `?source=${source}&user=${user}&pass=${pass}&function=external_status&agent_user=${agentId}&value=${value}`, {
            method: 'GET',
            mode: 'no-cors'
        });

            return true;
    } catch (error) {
        console.error('Error updating status:', error);
        return false;
    }
}

export async function externalDial({ agentId, phoneCode, phoneNumber, campaignId }) {
    try {
        const response = await fetch(URL_Vicidial + `?source=${source}&user=${user}&pass=${pass}&function=external_dial&agent_user=${agentId}&phone_code=1&search=YES&preview=NO&focus=YES&value=${phoneNumber}`, {
            method: 'GET',
            mode: 'no-cors'
        });
        console.log(response.text)
        return true;
    } catch (error) {
        console.error('Error making call:', error);
        return false;
    }
}
